import type { FaireProductEntity } from "../../entity_types/product";

export const p_qgpyfy39rv: FaireProductEntity = {
  token: "p_qgpyfy39rv",
  type: "product",
  name: "Maple Mallows",
  brandToken: "b_zufqgcwjpa",
  brandName: "Feral Foods",
  imageUrl:
    "https://cdn.faire.com/fastly/c87b91f1c3a87b0f3543d78022a2910d3b4fdd533cae6ff284c0216b6c03b7e0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ec3b82fef7e841f0dacfae1cdaab98dbfc993f0f3d0b445fc35b6c816ffa3543.jpeg",
    "https://cdn.faire.com/fastly/0b5b343bc6180873a409ae2d320decee23841681acf887b501407861b1c7e6f0.jpeg",
  ],
  priceDollars: 31.04,
  description:
    "A softer, cleaner marshmallow made for real nourishment.\n\nLight, fluffy, and naturally sweetened with organic maple syrup, these collagen-rich marshmallows melt beautifully into coffee, cocoa, matcha, or any cozy daily ritual. A nostalgic treat, reimagined with simple, real ingredients your body actually recognizes.\n\nUnlike conventional marshmallows, ours are made without corn syrup or refined sugar, using grass-fed gelatin as a natural source of collagen to support skin, joints, and connective tissue.\n\nWe use only organic, whole-food ingredients.\nNo fillers. No shortcuts.\n\nWhy Our Maple Mallows Are Different\n\n• A true collagen marshmallow made with grass-fed gelatin\n• Provides glycine, known to support relaxation and restful sleep\n• Traditionally used to support gut health and digestion\n• Sweetened with real maple syrup, offering trace minerals and a more balanced sweetness\n• A healthy marshmallow alternative with no corn syrup, preservatives, or artificial ingredients\n\nMelt them into your morning coffee or enjoy on their own as a daily ritual snack.\n\nEnjoy 1–2 per day consistently. With regular use, many begin to notice subtle support in sleep, skin, and overall nourishment.\n",
  tags: [],
  msrpDollars: 38.8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:00.613Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
